import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrModificationDirection.ts
var t = () => e("modificationDirection");
//#endregion
export { t as useTrModificationDirection };
